// extracted by mini-css-extract-plugin
export default {"wrapper":"box-flex_wrapper__vEnRn"};